// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2E9kH","signatureButtonsRight":"ModalSign_signatureButtonsRight__2bZ6k"};